import React, {useEffect, useRef, useState} from 'react';
import {Navigate} from "react-router-dom";
import {useTransitionEndEventName} from "../../hooks/useTransitionEndEventName";

function HaveAny(props) {
    const [state, setState] = useState({
        position: 'bottom',
        navigateTo: false,
    })
    const transitionableContainer = useRef()
    const transitionName = useTransitionEndEventName()
    const onLastTransitionOut = (delays, callback)=>{
        if (delays.length){
            if (transitionName) {
                const lastOut = () => {
                    delays[delays.length - 1].removeEventListener(transitionName, lastOut, true)
                    callback()
                }
                delays[delays.length - 1].removeEventListener(transitionName, lastOut, true)
                delays[delays.length - 1].addEventListener(transitionName, lastOut, true)
            } else {
                const timeOut = (delays.length + 1) * 0.05
                setTimeout(() => {
                    callback()
                }, timeOut)
            }
        }
    }
    const setAnswer = async (e)=>{
        const affirmative = e.target.value==="true"

        const transiationables = transitionableContainer.current.querySelectorAll('.transitionable')
        onLastTransitionOut(transiationables, async ()=>{
            const path = affirmative ? await props.yesPath() : await props.noPath()
            setState({...state,navigateTo: path})
        });
        setState({...state,position: 'top'})
    }
    useEffect(()=>{
        setState({...state,position:''})

    },[])
    if (state.navigateTo){
        return <Navigate to={state.navigateTo}/>
    }
    return (
        <div className={`question-transition ${state.position}`}>
            <div className="d-flex flex-column row">
                <div className={`mb-5 h3 transitionable delay-${props.delayStart} text-center form-label col`}>
                    {props.question}
                </div>
                <div className="py-1 col">
                    <div ref={transitionableContainer} className="row sussd-radio d-flex flex-wrap justify-content-evenly g-2">
                        <div className={`col transitionable delay-${props.delayStart + 1} form-check`}>
                            <input name="nonEuroCurrency"
                                   type="radio"
                                   id="haveAny1"
                                   className="form-check-input"
                                   value="true"
                                    onChange={setAnswer}
                            />
                            <label htmlFor="haveAny1" className="form-check-label">
                                <div className="d-flex flex-column align-items-center py-3 px-3">
                                    <span className="text-nowrap">Yes </span>
                                </div>
                            </label>
                        </div>
                        <div className={`col transitionable delay-${props.delayStart + 2} form-check`}>
                            <input name="nonEuroCurrency"
                                   type="radio"
                                   id="haveAny0"
                                   className="form-check-input"
                                   value="false"
                                   onChange={setAnswer}
                            />
                            <label htmlFor="haveAny0" className="form-check-label">
                                <div className="d-flex flex-column align-items-center py-3 px-3">
                                    <span className="text-nowrap">No </span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HaveAny;